export interface WidgetLoaderInfo {
  url: string;
  sri?: string;
}

interface WidgetVersionManifest {
  loader?: {
    url?: string;
    sri?: string;
  };
}

const DEFAULT_CDN_BASE = 'https://cdn.peta-cms.com';

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const buildWidgetLoaderScript = (
  siteId: string,
  loader: WidgetLoaderInfo = { url: `${DEFAULT_CDN_BASE}/widget.js` },
) => {
  const attrs = [`src="${loader.url}"`, `data-site-id="${siteId}"`];
  if (loader.sri) {
    attrs.push(`integrity="${loader.sri}"`, 'crossorigin="anonymous"');
  }
  attrs.push('defer');
  return `<script ${attrs.join(' ')}></script>`;
};

export const fetchWidgetLoaderInfo = async (
  cdnBase: string = DEFAULT_CDN_BASE,
): Promise<WidgetLoaderInfo> => {
  const normalizedBase = trimTrailingSlash(cdnBase);
  const res = await fetch(`${normalizedBase}/versions/manifest.json`, {
    method: 'GET',
    credentials: 'omit',
  });

  if (!res.ok) {
    throw new Error(`widget manifest fetch failed: ${res.status}`);
  }

  const manifest = (await res.json()) as WidgetVersionManifest;
  const loaderInfo: WidgetLoaderInfo = {
    url: manifest.loader?.url
      ? new URL(manifest.loader.url, `${normalizedBase}/`).toString()
      : `${normalizedBase}/widget.js`,
  };
  if (manifest.loader?.sri !== undefined) {
    loaderInfo.sri = manifest.loader.sri;
  }
  return loaderInfo;
};
